export default "__VITE_ASSET__C3JCP3ft__"